import { render, staticRenderFns } from "./b4.vue?vue&type=template&id=70dc73a5&scoped=true&"
import script from "./b4.vue?vue&type=script&lang=js&"
export * from "./b4.vue?vue&type=script&lang=js&"
import style0 from "./b4.vue?vue&type=style&index=0&id=70dc73a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc73a5",
  null
  
)

export default component.exports